import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Implement Firebase App Check to prevent API key abuse.
// Steps:
//   1. Enable App Check in Firebase Console → App Check → Apps
//   2. Register a reCAPTCHA v3 provider and copy the site key
//   3. npm install firebase (already present) — App Check is included
//   4. Uncomment and configure the block below, replacing RECAPTCHA_SITE_KEY
//
// import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
// initializeAppCheck(app, {
//   provider: new ReCaptchaV3Provider('RECAPTCHA_SITE_KEY'),
//   isTokenAutoRefreshEnabled: true,
// });

const firebaseEnv = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const requiredFirebaseFields = [
  'apiKey',
  'authDomain',
  'projectId',
  'storageBucket',
  'messagingSenderId',
  'appId'
];

const missingFirebaseFields = requiredFirebaseFields.filter((field) => {
  const value = firebaseEnv[field];
  return typeof value !== 'string' || value.trim() === '';
});

if (missingFirebaseFields.length > 0) {
  throw new Error(
    'Firebase web config is missing. ' +
      `Populate the frontend .env file with REACT_APP_FIREBASE_* values before starting the app. Missing: ${missingFirebaseFields
        .map((field) => `REACT_APP_FIREBASE_${field.replace(/([A-Z])/g, '_$1').toUpperCase()}`)
        .join(', ')}.`
  );
}

// Admin/Builder Firebase config (guidesofia-access-control)
const firebaseConfig = {
  ...firebaseEnv,
  apiKey: firebaseEnv.apiKey.trim(),
  authDomain: firebaseEnv.authDomain.trim(),
  projectId: firebaseEnv.projectId.trim(),
  storageBucket: firebaseEnv.storageBucket.trim(),
  messagingSenderId: firebaseEnv.messagingSenderId.trim(),
  appId: firebaseEnv.appId.trim(),
  measurementId: firebaseEnv.measurementId?.trim() || undefined
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
